import { useSuspenseQuery } from "@tanstack/react-query";
import { customerStateWidgetQueryOptions } from "@/features-root-user/service/dashboard";
import { Suspense } from "react";
import RootUserLayout from "../layout";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import SalesFlareBoard, { Opportunity } from "./salesflare-board";

function LeadsContent() {
  const { data } = useSuspenseQuery(customerStateWidgetQueryOptions);
  return <SalesFlareBoard opportunities={data as Opportunity[]} />;
}

export default function LeadsManagement() {
  return (
    <RootUserLayout pageTitle="Leads Dashboard">
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Leads..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <LeadsContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}
